import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-6 gap-x-4 gap-y-4" }
const _hoisted_2 = {
  key: 0,
  class: "col-span-6"
}
const _hoisted_3 = {
  for: "excel-file",
  class: "flex justify-center items-center p-12 bg-blue-50 rounded-lg border-2 border-blue-300 border-dashed"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-green-600" }, "Выбрать документ", -1)
const _hoisted_5 = {
  key: 1,
  class: "col-span-6"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Список существующих данных", -1)
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = { class: "border-collapse border border-slate-500 w-full mt-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "border border-slate-600 p-2" }, "Наименование"),
    /*#__PURE__*/_createElementVNode("th", { class: "border border-slate-600 p-2" }, "Индекс")
  ])
], -1)
const _hoisted_10 = { class: "border border-slate-700 p-2" }
const _hoisted_11 = { class: "border border-slate-700 p-2" }

import { ref } from "vue";
import Modal from "@/components/common/Modal.vue";
import { NomenclatureDataService } from "@/services";
import { useToast } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  props: {
  show: {
    type: Boolean,
    default: false,
  },
},
  emits: ["hide"],
  setup(__props, { emit }) {

const props = __props



const toast = useToast();

const excelFile = ref();
const errorFields = ref([]);

const uploadExcelFile = async () => {
  let form = new FormData();
  form.append("file", excelFile.value.files[0]);
  try {
    await NomenclatureDataService.uploadExcel(form).then((response) => {
      console.log(response);
    });
    toast.success("Данные успешно загружены");
    emit("hide");
  } catch (error) {
    toast.error("Ошибка");
    errorFields.value = error.response.data.data || [];
  }
};

const closeHandler = () => {
  excelFile.value = null;
  errorFields.value = [];
  emit("hide");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    onClose: closeHandler,
    show: __props.show,
    title: "Загрузить номенаклатуру"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (errorFields.value.length <= 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("label", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("input", {
                  id: "excel-file",
                  type: "file",
                  ref: (_value, _refs) => {
                    _refs['excelFile'] = _value
                    excelFile.value = _value
                  },
                  onChange: uploadExcelFile,
                  hidden: ""
                }, null, 544)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", {
                class: "table-scroll",
                style: {"--table-min-width":"480px"},
                tabindex: "0",
                role: "region",
                "aria-label": _ctx.$t('common.scrollableTable')
              }, [
                _createElementVNode("table", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errorFields.value, (errorField, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_10, _toDisplayString(errorField.name), 1),
                        _createElementVNode("td", _hoisted_11, _toDisplayString(errorField.index), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ], 8, _hoisted_7)
            ]))
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})